import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = ({ loaderVisible, isBlankLoader }: any) => {
  return (
    <Backdrop
      sx={{
        backgroundColor: isBlankLoader && "white",
        zIndex: "10",
      }}
      open={loaderVisible}
    >
      <CircularProgress color="primary" size={50} />
    </Backdrop>
  );
};

export default Loader;
